<template>
  <v-btn
    text
    link
    @click="doGetStaffLink()"
  >
    <span class="lbl-textbox">
      <slot>Details</slot>
    </span>
  </v-btn>

</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'
  import {
    _COMMIT_LOG, ACCT_GET_ACCOUNT_BY_EXT_KEY,
  } from '../../store/actions.types'

  export default {
    // events
    // itemCreated
    // itemUpdated
    name: 'PlatAccountActions',

    mixins: [basicMixin],

    props: {
      custId: {
        type: Number,
        default: 0,
      },
    },
    data: () => ({
      currentObject: {},
      snapshotObject: {},
      formMode: 'read',
      formErrors: [],
      overlayAbsolute: true,
      overlayDisplay: false,
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'profile']),
    },
    watch: {
    },
    created () {
      this.init()
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        getAccountByExtKey: ACCT_GET_ACCOUNT_BY_EXT_KEY,
      }),
      async init () {
        this.commitLog({ message: `Initializing ${name} setting values!`, custId: this.custId })
      },
      async doOpenPow (item) {
        this.commitLog({ message: 'Opening POW from customer ID', custId: this.custId })
        // const returnedAccount = await this.getAccountByExtKey({ key: this.custId })
        // this.commitLog({ message: 'account returned from external key', record: returnedAccount })
        const url = `${this.powUrl}/record.php?id=${this.custId}`
        window.open(url, '_blank')
      },
      async doGetCustomerLink () {
        this.commitLog({ message: 'getting account from external key', custId: this.custId })
        const returnedAccount = await this.getAccountByExtKey({ key: this.custId })
        this.commitLog({ message: 'account returned from external key', record: returnedAccount })
        const url = `/#/app/account/${returnedAccount.rowkey}`
        window.open(url, '_blank')
      },
      async doGetStaffLink () {
        this.commitLog({ message: 'getting account from external key', custId: this.custId })
        const returnedAccount = await this.getAccountByExtKey({ key: this.custId })
        this.commitLog({ message: 'account returned from external key', record: returnedAccount })
        const url = `/#/staff/account/${returnedAccount.rowkey}`
        window.open(url, '_blank')
      },
    },
  }
</script>
